import { CACHE_KEY_LIST_USER } from '@/modules/admin/contants/users';
import UserApiService from '@/modules/admin/services/UserApiService';
import { createContextList } from '@/utils/createContextList';
import { createPaginationHook } from '@/utils/createPaginationHook';

export const useUpdatePersonCell = () => {
  const useTablePagination = createPaginationHook(CACHE_KEY_LIST_USER, UserApiService.search);
  const { Provider, useList } = createContextList(useTablePagination, CACHE_KEY_LIST_USER, {
    size: 20
  });
  
  return {
    Provider,
    useList
  };
};
